import Home from "./views/Home.vue";

let routes = [
  {
    path: "/login",
    component: () => import("@/views/Login.vue"),
    name: "",
    hidden: true,
  },
  {
    path: "/404",
    component: () => import("@/views/404.vue"),
    name: "",
    hidden: true,
  },
  {
    path: "/",
    component: Home,
    name: "",
    iconCls: "el-icon-s-platform",
    leaf: true, //只有一个节点
    children: [
      {
        path: "/index",
        component: () => import("@/views/index/index.vue"),
        name: "工作台",
      },
    ],
    redirect: {
      path: "/index",
    },
  },
  {
    path: "/",
    component: Home,
    name: "扶贫馆",
    iconCls: "el-icon-s-platform",
    children: [
      {
        path: "/povertyCenter",
        component: () => import("@/views/povertyCenter/center.vue"),
        name: "扶贫馆",
      },
      {
        path: "/povertyCenter/company",
        component: () => import("@/views/povertyCenter/company.vue"),
        name: "扶贫馆企业",
        hidden: true
      },
      {
        path: "/povertyCenter/good",
        component: () => import("@/views/povertyCenter/good.vue"),
        name: "扶贫馆企业产品",
        hidden: true
      },
    ],
  },
  {
    path: "/",
    component: Home,
    name: "",
    iconCls: "el-icon-user-solid",
    leaf: true, //只有一个节点
    children: [
      {
        path: "/customerManage",
        component: () => import("@/views/customerManage/index.vue"),
        name: "用户管理",
      },
      {
        path: "/cardPage",
        component: () => import("@/views/cardPage/index.vue"),
        name: "名片详情",
        hidden: true,
      },
    ],
  },
  {
    path: "/",
    component: Home,
    name: "企业管理",
    iconCls: "el-icon-office-building",
    children: [
      {
        path: "/companyManage",
        component: () => import("@/views/companyManage/main.vue"),
        name: "名片管理",
        children: [
          {
            path: "/cardStyle",
            component: () => import("@/views/cardStyle/index.vue"),
            name: "名片模板",
          },
          {
            path: "/companyManage/list",
            component: () => import("@/views/companyManage/index.vue"),
            name: "名片信息",
          },
          {
            path: "/companyManage/verify",
            component: () => import("@/views/companyManage/Verify.vue"),
            name: "名片审核",
          },
          {
            path: "/operationRecords",
            component: () => import("@/views/operationRecords/index.vue"),
            name: "操作记录",
          },
        ],
      },
      {
        path: "/companyManage/goodsAudit",
        component: () => import("@/views/goodsAudit/index.vue"),
        name: "商品管理",
        hidden: false,
      },
      {
        path: "/goodsCategory",
        component: () => import("@/views/goodsCategory/index.vue"),
        name: "商品分类管理",
        hidden: false,
      },
      {
        path: "/companyCardPage",
        component: () => import("@/views/companyCardPage/index.vue"),
        name: "企业详情",
        hidden: true,
      },
      {
        path: "/globalDefaultConfig",
        component: () => import("@/views/globalDefaultConfig/index.vue"),
        name: "全局默认配置",
      },
      // { path: '/cardStyle', component: () => import('@/views/cardStyle/index.vue'), name: '名片模板' },
      // { path: '/companyManage', component: () => import('@/views/companyManage/index.vue'), name: '企业管理' },
      // { path: '/companyCardPage', component: () => import('@/views/companyCardPage/index.vue'), name: '企业详情', hidden: true },
      // { path: '/permissionsManage', component: () => import('@/views/permissionsManage/index.vue'), name: '权限管理' },
      // { path: '/operationRecords', component: () => import('@/views/operationRecords/index.vue'), name: '操作记录' }
    ],
  },
  // {
  //   path:"/broadcast",
  //   component: () => import("@/views/broadcast.vue"),
  //   name:"直播管理",
  // },
  {
    path: "/",
    component: Home,
    name: "直播管理",
    iconCls: "el-icon-video-camera-solid",
    
    children: [
      {
        path: "/broadcast",
        component: () => import("@/views/liveBroadcast/broadcast.vue"),
        name: "直播管理",
      },
    ],
    // redirect: {
    //   path: "/index",
    // },

  },

 


  {
    path: "/",
    component: Home,
    name: "资金管理",
    iconCls: "el-icon-s-marketing",
    children: [
      {
        path: "/commissionWithOut",
        component: () => import("@/views/commissionWithOut/index.vue"),
        name: "佣金提现",
      },
      {
        path: "/cashOut",
        component: () => import("@/views/cashOut/index.vue"),
        name: "提现申请",
        // children: [{
        //   path: '/cashOut/main',
        //   component: () => import('@/views/cashOut/main.vue'),
        //   name: '提现申请',
        // }, {
        //   path: '/cashOut/cashOutDetails/:id',
        //   component: () => import('@/views/cashOut/cashOutDetails.vue'),
        //   name: '提现详情',
        //   hidden: true
        // }]
      },
      {
        path: "/rechargeManage",
        component: () => import("@/views/rechargeManage/index.vue"),
        name: "充值管理",
      },
    ],
  },
  // {
  //   path: '/data',
  //   component: Home,
  //   name: '数据中心',
  //   iconCls: 'fa fa-bar-chart',
  //   children: [{
  //       path: '/data/smartCard',
  //       component: () => import('@/views/smartCard/index.vue'),
  //       name: '互见智能名片'
  //     },
  //     {
  //       path: '/data/crmCard',
  //       component: () => import('@/views/crmCard/index.vue'),
  //       name: '互见智能CRM'
  //     }
  //   ]
  // },
  {
    path: "/",
    component: Home,
    name: "小程序管理",
    iconCls: "el-icon-mobile-phone",
    children: [
      {
        path: "/codeManage",
        component: () => import("@/views/codeManage/index.vue"),
        name: "代码管理",
      },
      {
        path: "/versionManage",
        component: () => import("@/views/versionManage/index.vue"),
        name: "版本管理",
      },
      {
        path: "/wxappletManage",
        component: () => import("@/views/wxappletManage/index.vue"),
        name: "授权小程序管理",
      },
    ],
  },
  {
    path: "/",
    component: Home,
    name: "",
    iconCls: "el-icon-s-order",
    leaf: true, //只有一个节点
    children: [
      {
        path: "/ordersManage",
        component: () => import("@/views/ordersManage/index.vue"),
        name: "总订单管理",
      },
    ],
    redirect: {
      path: "/index",
    },
  },
  {
    path: "/",
    component: Home,
    name: "",
    iconCls: "el-icon-setting",
    leaf: true, //只有一个节点
    children: [
      {
        path: "/permissionsManage",
        component: () => import("@/views/permissionsManage/index.vue"),
        name: "权限管理",
      },
    ],
    redirect: {
      path: "/index",
    },
  },
  {
    path: "/",
    component: Home,
    name: "",
    iconCls: "el-icon-message-solid",
    leaf: true, //只有一个节点
    children: [
      {
        path: "/companyNotice",
        component: () => import("@/views/companyNotice/index.vue"),
        name: "更新公告",
      },
    ],
    redirect: {
      path: "/index",
    },
  },

  {
    path: "*",
    hidden: true,
    redirect: {
      path: "/404",
    },
  },
];

export default routes;

// export const constantRouterMap = [
//     {
//         path: '/',
//         redirect: '/login'
//     },
//     {
//         path: '/login',
//         component: () => import('@/views/Login.vue'),
//         name: '',
//         hidden: true
//     },
//     {
//         path: '/404',
//         component: () => import('@/views/404.vue'),
//         name: '',
//         hidden: true
//     },
// ]

// export const asyncRouterMap = [

// ]



// WEBPACK FOOTER //
// ./src/routes.js